const defaultState = {
    // 紀錄 user 現在配到哪個獎品
    currentPrizeUUID: '',
    currentUnanimationEntriesUUID: '',
    // 代表純獎流程的前置作業都跑好且條件也都滿足了，遊戲隨時可以開始的意思，可以把它作為遊戲動畫觸發的依賴
    isGameReadyToPlay: false
};

const UPDATE_PURE_PRIZE_STATE = 'purePrizeState/UPDATE_PURE_PRIZE_STATE';

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_PURE_PRIZE_STATE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export function setCurrentPrizeUUID(currentPrizeUUID) {
    return {
        type: UPDATE_PURE_PRIZE_STATE,
        payload: {
            currentPrizeUUID
        }
    };
}

export function clearCurrentPrizeUUID() {
    return {
        type: UPDATE_PURE_PRIZE_STATE,
        payload: {
            currentPrizeUUID: ''
        }
    };
}

export function setCurrentUnanimationEntriesUUID(currentUnanimationEntriesUUID) {
    return {
        type: UPDATE_PURE_PRIZE_STATE,
        payload: {
            currentUnanimationEntriesUUID
        }
    };
}

export function clearCurrentUnanimationEntriesUUID() {
    return {
        type: UPDATE_PURE_PRIZE_STATE,
        payload: {
            currentUnanimationEntriesUUID: ''
        }
    };
}

export function setGameAlreadyToPlay() {
    return {
        type: UPDATE_PURE_PRIZE_STATE,
        payload: {
            isGameReadyToPlay: true
        }
    };
}

export function setGameNotReadyToPlay() {
    return {
        type: UPDATE_PURE_PRIZE_STATE,
        payload: {
            isGameReadyToPlay: false
        }
    };
}

export default reducer;
